import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import animationData from "../../assets/samblaLogoStroke.json";

interface SamblaLogoLottieProps {
  size?: number;
}

export function SamblaLogoLottie({ size = 120 }: SamblaLogoLottieProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: !prefersReducedMotion,
      autoplay: !prefersReducedMotion,
      animationData,
    });
    if (prefersReducedMotion) {
      // Show the final static frame instead of animating
      animation.goToAndStop(Math.max(animation.totalFrames / 2), true);
    }
    return () => animation.destroy();
  }, []);

  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      style={{ width: size, height: size }}
    />
  );
}
